/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo, useState } from "react";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { MRT_Localization_PT_BR } from "material-react-table/locales/pt-BR";
import "./style.scss";
import { DeleteApi, GetApi, PostApi, PutApi } from "../services/auth";
import { isValid } from "../services/utils";
import { Button, CustomInput } from "src/Components/customInput";

import { ReactComponent as Add } from "src/Assets/Icons/add.svg";
import { ReactComponent as Close } from "src/Assets/Icons/close.svg";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import showToast from "../services/toastyService";

export default function Vendas({ darkMode }) {
  const [vendas, setVendas] = useState([]);
  const [movimentacoes, setMovimentacoes] = useState([]);
  const [filteredData, setFilteredData] = useState([]);

  const [embarcadas, setEmbarcadas] = useState(false);
  const [incompletas, setIncompletas] = useState(false);

  const [showDetalhes, setShowDetalhes] = useState(false);

  const [qualidades, setQualidades] = useState([]);
  const [peneiras, setPeneiras] = useState([]);

  const [selectRow, setSelectRow] = useState({});
  const peneiraBase = [
    "19 acima",
    "17/19",
    "17/18",
    "16 acima",
    "15/16",
    "14/16",
    "14 acima",
    "13/14/15",
    "12 acima",
    "Vários",
  ];

  const cafeData = {
    Arábica: {
      "Rio Minas": peneiraBase,
      Light: peneiraBase,
      "Fine Cup": peneiraBase,
      "Good Cup": peneiraBase,
      Grinders: ["Grinders"],
      "300 Defeitos": ["300 Defeitos"],
      "500 Defeitos": ["500 Defeitos"],
      "600 Defeitos": ["600 Defeitos"],
      "800 Defeitos": ["800 Defeitos"],
    },
    Conilon: {
      Conilon: peneiraBase,
      Neutro: peneiraBase,
      Grinders: ["Grinders"],
      "300 Defeitos": ["300 Defeitos"],
      "500 Defeitos": ["500 Defeitos"],
      "600 Defeitos": ["600 Defeitos"],
      "800 Defeitos": ["800 Defeitos"],
    },
  };

  function formatarMoeda(moeda) {
    switch (moeda) {
      case "USD":
        return "Dólar (USD)";
      case "EUR":
        return "Euro (EUR)";
      default:
        return "Real (BRL)";
    }
  }

  function formatarValor(valor, moeda = "BRL") {
    if (valor == null || isNaN(valor)) {
      switch (moeda) {
        case "USD":
          return "US$ 0,00";
        case "EUR":
          return "€ 0,00";
        default:
          return "R$ 0,00";
      }
    }

    switch (moeda) {
      case "USD":
        return valor.toLocaleString("en-US", {
          style: "currency",
          currency: "USD",
          minimumFractionDigits: 2,
        });
      case "EUR":
        return valor.toLocaleString("de-DE", {
          style: "currency",
          currency: "EUR",
          minimumFractionDigits: 2,
        });
      default:
        return valor.toLocaleString("pt-BR", {
          style: "currency",
          currency: "BRL",
          minimumFractionDigits: 2,
        });
    }
  }

  function formatarData(dataStr) {
    if (!dataStr) return "";

    const partes = dataStr.split("-");

    if (partes.length === 2) {
      const [ano, mes] = partes;
      const nomeMes = new Date(`${ano}-${mes}-01`).toLocaleString("pt-BR", {
        month: "long",
      });
      return `${nomeMes} de ${ano}`;
    }

    if (partes.length === 3) {
      const data = new Date(dataStr);
      return data.toLocaleDateString("pt-BR");
    }

    return dataStr;
  }

  const tableTheme = useMemo(() => {
    return createTheme({
      palette: {
        mode: darkMode ? "dark" : "light",
        primary: { main: darkMode ? "#90caf9" : "#1976d2" },
        background: { default: darkMode ? "#121212" : "#ffffff" },
        text: { primary: darkMode ? "#ffffff" : "#000000" },
      },
      typography: {
        button: { textTransform: "none", fontSize: "1rem" },
      },
      components: {
        MuiTooltip: {
          styleOverrides: {
            tooltip: { fontSize: "1.1rem" },
          },
        },
        MuiSwitch: {
          styleOverrides: {
            thumb: {
              color: darkMode ? "#ffffff" : "#000000",
            },
          },
        },

        MuiCssBaseline: {
          styleOverrides: {
            ":root": {
              "--variant-containedBg": darkMode ? "#00bfa5" : "#1976d2",
              "--variant-containedColor": "#fff",
              "--variant-containedHoverBg": darkMode ? "#009688" : "#1565c0",
            },
          },
        },
      },
    });
  }, [darkMode]);

  const columns = useMemo(
    () => [
      {
        accessorKey: "NV",
        header: "NV/VP",
        Cell: ({ row }) =>
          isValid(row.original.NV)
            ? `${row.original.Exportador === "Nicchio Café Ltda" ? "NV" : "VP"} - ${row.original.NV || ""}`
            : "",
        enableEditing: false,
      },
      { accessorKey: "Contrato", header: "Contrato" },
      { accessorKey: "Importador", header: "Importador" },
      {
        accessorKey: "Data_Venda",
        header: "Data Venda",
        Cell: ({ cell }) => formatarData(cell.getValue()),
        muiEditTextFieldProps: {
          type: "date",
          InputLabelProps: { shrink: true },
        },
      },
      {
        accessorKey: "Quantidade",
        header: "Quantidade",
        muiEditTextFieldProps: {
          type: "number",
          InputLabelProps: { shrink: true },
        },
      },
      {
        accessorKey: "PV",
        header: "Preço de Venda",
        muiEditTextFieldProps: {
          type: "number",
          InputLabelProps: { shrink: true },
        },
        Cell: ({ cell, row }) =>
          formatarValor(cell.getValue(), row.original.Moeda),
      },
      {
        accessorKey: "Prev_de_Embarque",
        header: "Previsão de Embarque",
        Cell: ({ cell }) => formatarData(cell.getValue()),
        muiEditTextFieldProps: {
          type: "month",
          InputLabelProps: { shrink: true },
        },
      },
      {
        accessorKey: "Data_Carregamento",
        header: "Data de Carregamento",
        Cell: ({ cell }) => formatarData(cell.getValue()),
        muiEditTextFieldProps: {
          type: "date",
          InputLabelProps: { shrink: true },
        },
      },
      {
        header: "Valor da Venda",
        muiEditTextFieldProps: {
          type: "number",
          InputLabelProps: { shrink: true },
        },
        accessorFn: (row) => row.PV * row.Quantidade,
        Cell: ({ row }) =>
          formatarValor(
            row.original.PV * row.original.Quantidade,
            row.original.Moeda
          ),
      },
    ],
    []
  );

  useEffect(() => {
    if (!isValid(vendas)) {
      GetInfo();
    }
  }, []);

  function GetInfo() {
    GetApi("vendas")
      .then((res) => {
        setVendas(res?.data.vendas);
        showToast("success", res.message);
      })
      .catch((error) => {
        console.log(error);
      });

    GetApi("cambios")
      .then((res) => {
        setMovimentacoes(res?.data?.cambios);
        showToast("success", res.message);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  useEffect(() => {
    let newData = [...vendas];

    if (embarcadas) {
      newData = newData.filter(
        (item) => item.Data_Carregamento && isValid(item.Data_Carregamento)
      );
    }

    if (incompletas) {
      newData = newData.filter((item) => {
        const relacionados = movimentacoes.filter(
          (mov) => mov.Venda_id === item.Venda_id
        );

        const cambioContratadoTotal = relacionados.reduce(
          (total, mov) => total + (mov.Cambio_Contratado || 0),
          0
        );

        const valorDaVenda = (item.PV || 0) * (item.Quantidade || 0);
        return valorDaVenda > cambioContratadoTotal;
      });
    }

    setFilteredData(newData);
  }, [vendas, embarcadas, incompletas]);

  const [showPopup, setShowpoup] = useState(false);
  const [novaVenda, setNovaVenda] = useState({});
  const [camposVazios, setCamposVazios] = useState([]);

  function gerarId(venda) {
    const base = `${venda.nvnp}-${venda.exportador?.charAt(0)}-${venda.precoVenda}`;
    return base
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[^a-zA-Z0-9]/g, "")
      .toUpperCase();
  }

  function HandleAdd() {
    const novaId = gerarId(novaVenda);

    const newData = {
      Venda_id: novaId,
      NV: novaVenda.nvnp,
      Exportador: novaVenda.exportador,
      Moeda: novaVenda.moeda,
      Tipo_de_venda: novaVenda.tipoVenda,
      Importador: novaVenda.importador,
      Tipo_Cafe: novaVenda.tipoCafe,
      Qualidade: novaVenda.qualidade,
      Peneira: novaVenda.peneira,
      Prev_de_Embarque: novaVenda.previsaoEmbarque,
      Data_Carregamento: novaVenda.Data_Carregamento,
      Quantidade: novaVenda.quantidadeSacos,
      Data_Venda: novaVenda.dataVenda,
      Contrato: novaVenda.contrato,
      PV: novaVenda.precoVenda,
      Observacoes: novaVenda.observacoes,
    };

    const campos_vazios = Object.entries(newData)
      .filter(
        ([campo]) =>
          campo !== "Venda_id" &&
          campo !== "Data_Carregamento" &&
          campo !== "Observacoes" &&
          campo !== "PV"
      )
      .filter(
        ([_, valor]) => valor === null || valor === undefined || valor === ""
      )
      .map(([campo]) => campo);

    setCamposVazios(campos_vazios);

    if (campos_vazios.length > 0) {
      return;
    }

    PostApi("vendas", newData).then(() => {
      GetInfo();
      setShowpoup(false);
    });
  }

  return (
    <div className="Vendas">
      <button
        className={`-popupFade ${showPopup ? "" : "hide"}`}
        onClick={() => setShowpoup(false)}
      />
      {showPopup && (
        <div className="-popup">
          <h3> Nova Venda </h3>

          <div className="content">
            <CustomInput
              Class={
                camposVazios?.includes("Venda_id") && !isValid(novaVenda.nvnp)
                  ? "alert"
                  : ""
              }
              Style="Default"
              Type="text"
              Placeholder="NV/VP"
              OnChange={(e) =>
                setNovaVenda((prev) => ({
                  ...prev,
                  nvnp: e.target.value,
                }))
              }
            />

            <CustomInput
              Class={
                camposVazios?.includes("Exportador") &&
                !isValid(novaVenda.exportador)
                  ? "alert"
                  : ""
              }
              Style="Default"
              Type="select"
              Placeholder="Exportador"
              OnChange={(e) =>
                setNovaVenda((prev) => ({
                  ...prev,
                  exportador: e.target.value,
                }))
              }
            >
              <option value="">Selecionar Exportador</option>
              <option value="Nicchio Café Ltda">Nicchio Café</option>
              <option value="Vix Café Ltda">Vixport</option>
            </CustomInput>

            <CustomInput
              Class={
                camposVazios?.includes("Moeda") && !isValid(novaVenda.moeda)
                  ? "alert"
                  : ""
              }
              Style="Default"
              Type="select"
              Placeholder="Moeda"
              OnChange={(e) =>
                setNovaVenda((prev) => ({
                  ...prev,
                  moeda: e.target.value,
                }))
              }
            >
              <option value="">Selecionar Moeda</option>
              <option value="USD">Dólar (USD)</option>
              <option value="EUR">Euro (EUR)</option>
            </CustomInput>

            <CustomInput
              Class={
                camposVazios?.includes("Tipo_de_venda") &&
                !isValid(novaVenda.tipoVenda)
                  ? "alert"
                  : ""
              }
              Style="Default"
              Type="select"
              Placeholder="Tipo de Venda"
              OnChange={(e) =>
                setNovaVenda((prev) => ({
                  ...prev,
                  tipoVenda: e.target.value,
                }))
              }
            >
              <option value="">Selecionar Tipo de Venda</option>
              <option value="FIXO">FIXO</option>
              <option value="DIFERENCIAL">DIFERENCIAL</option>
            </CustomInput>

            <CustomInput
              Class={
                camposVazios?.includes("Importador") &&
                !isValid(novaVenda?.importador)
                  ? "alert"
                  : ""
              }
              Style="Default"
              Type="text"
              Placeholder="Importador"
              OnChange={(e) =>
                setNovaVenda((prev) => ({
                  ...prev,
                  importador: e.target.value,
                }))
              }
            />

            <CustomInput
              Class={
                camposVazios?.includes("Importador") &&
                !isValid(novaVenda.tipoCafe)
                  ? "alert"
                  : ""
              }
              Style="Default"
              Type="select"
              Placeholder="Tipo de Café"
              OnChange={(e) => {
                const tipoCafe = e.target.value;
                setNovaVenda((prev) => ({
                  ...prev,
                  tipoCafe,
                  qualidade: "",
                  peneira: "",
                }));

                if (tipoCafe && cafeData[tipoCafe]) {
                  setQualidades(Object.keys(cafeData[tipoCafe]));
                  setPeneiras([]);
                } else {
                  setQualidades([]);
                  setPeneiras([]);
                }
              }}
            >
              <option value="">Selecionar Tipo de Café</option>
              <option value="Arábica">Arábica</option>
              <option value="Conilon">Conilon</option>
            </CustomInput>

            <CustomInput
              Class={
                camposVazios?.includes("Qualidade") &&
                !isValid(novaVenda.quantidade)
                  ? "alert"
                  : ""
              }
              Style="Default"
              Type="select"
              Placeholder="Qualidade"
              OnChange={(e) => {
                const qualidade = e.target.value;
                setNovaVenda((prev) => ({
                  ...prev,
                  qualidade,
                  peneira: "",
                }));

                const tipo = novaVenda.tipoCafe;
                if (tipo && qualidade && cafeData[tipo]?.[qualidade]) {
                  setPeneiras(cafeData[tipo][qualidade]);
                } else {
                  setPeneiras([]);
                }
              }}
            >
              <option value="">
                Selecionar Qualidade (Selecione Tipo de Café)
              </option>
              {qualidades.map((q) => (
                <option key={q} value={q}>
                  {q}
                </option>
              ))}
            </CustomInput>

            <CustomInput
              Class={
                camposVazios?.includes("Peneira") && !isValid(novaVenda.peneira)
                  ? "alert"
                  : ""
              }
              Style="Default"
              Type="select"
              Placeholder="Peneira"
              OnChange={(e) =>
                setNovaVenda((prev) => ({
                  ...prev,
                  peneira: e.target.value,
                }))
              }
            >
              <option value="">Selecionar Peneira (Selecione Qualidade)</option>
              {peneiras.map((p) => (
                <option key={p} value={p}>
                  {p}
                </option>
              ))}
            </CustomInput>

            <CustomInput
              Class={
                camposVazios?.includes("Prev_de_Embarque") &&
                !isValid(novaVenda.previsaoEmbarque)
                  ? "alert"
                  : ""
              }
              Style="Default"
              Type="month"
              Placeholder="Previsão de Embarque"
              OnChange={(e) =>
                setNovaVenda((prev) => ({
                  ...prev,
                  previsaoEmbarque: e.target.value,
                }))
              }
            />

            <CustomInput
              Style="Default"
              Type="date"
              Placeholder="Data de Carregamento"
              OnChange={(e) =>
                setNovaVenda((prev) => ({
                  ...prev,
                  Data_Carregamento: e.target.value,
                }))
              }
            />

            <CustomInput
              Class={
                camposVazios?.includes("Quantidade") &&
                !isValid(novaVenda.quantidadeSacos)
                  ? "alert"
                  : ""
              }
              Style="Default"
              Type="number"
              Placeholder="Quantidade de Sacos"
              OnChange={(e) =>
                setNovaVenda((prev) => ({
                  ...prev,
                  quantidadeSacos: e.target.value,
                }))
              }
            />

            <CustomInput
              Class={novaVenda.tipoVenda === "DIFERENCIAL" ? "disable" : ""}
              Style="Default"
              Type="number"
              Placeholder="Preço de Venda (por 60kg)"
              OnChange={(e) =>
                setNovaVenda((prev) => ({
                  ...prev,
                  precoVenda: e.target.value,
                }))
              }
            />

            <CustomInput
              Class={
                camposVazios?.includes("Data_Venda") &&
                !isValid(novaVenda.dataVenda)
                  ? "alert"
                  : ""
              }
              Style="Default"
              Type="date"
              Placeholder="Data de Venda"
              OnChange={(e) =>
                setNovaVenda((prev) => ({
                  ...prev,
                  dataVenda: e.target.value,
                }))
              }
            />

            <CustomInput
              Class={
                camposVazios?.includes("Contrato") &&
                !isValid(novaVenda.contrato)
                  ? "alert"
                  : ""
              }
              Style="Default"
              Type="text"
              Placeholder="Contrato"
              OnChange={(e) =>
                setNovaVenda((prev) => ({
                  ...prev,
                  contrato: e.target.value,
                }))
              }
            />

            <CustomInput
              Class={
                camposVazios?.includes("Observacoes") &&
                !isValid(novaVenda.observacoes)
                  ? "alert"
                  : ""
              }
              Style="Default"
              Type="text"
              Placeholder="Observações da Venda"
              OnChange={(e) =>
                setNovaVenda((prev) => ({
                  ...prev,
                  observacoes: e.target.value,
                }))
              }
            />
          </div>

          {camposVazios.length > 1 && <h4> Preencha Todos os campos. </h4>}

          <Button ClassName="icon" OnClick={() => HandleAdd()}>
            <Add /> Adicionar
          </Button>

          <button className="close" onClick={() => setShowpoup(false)}>
            <Close />
          </button>
        </div>
      )}

      <button
        className={`-popupFade ${showDetalhes ? "" : "hide"}`}
        onClick={() => setShowDetalhes(false)}
      />
      {showDetalhes &&
        (() => {
          const valorDaVenda = selectRow.PV * selectRow.Quantidade;

          const filtrados = movimentacoes.filter(
            (item) => item.Venda_id === selectRow.Venda_id
          );

          const cambioContratadoTotal = filtrados.reduce(
            (total, item) => total + (item.Cambio_Contratado || 0),
            0
          );

          const totalPonderado = filtrados.reduce(
            (acc, item) =>
              acc + (item.Cambio_Contratado || 0) * (item.Taxa_de_Cambio || 0),
            0
          );

          const mediaCambio = cambioContratadoTotal
            ? totalPonderado / cambioContratadoTotal
            : 0;

          return (
            <div className="-popup detalhes">
              <div className="content">
                <h5> Detalhes da Venda {selectRow.NV} </h5>
                <h6> Informações da Venda </h6>
                <p>
                  <b>Exportador:</b>
                  {selectRow.Exportador}
                </p>
                <p>
                  <b>Tipo de Venda:</b>
                  {selectRow.Tipo_de_venda}
                </p>
                <p>
                  <b>Importador:</b>
                  {selectRow.Importador}
                </p>
                <p>
                  <b>Tipo de Café:</b>
                  {selectRow.Tipo_Cafe}
                </p>
                <p>
                  <b>Qualidade:</b>
                  {selectRow.Qualidade}
                </p>
                <p>
                  <b>Peneira:</b>
                  {selectRow.Peneira}
                </p>
                <p>
                  <b>Previsão de Embarque:</b>
                  {formatarData(selectRow.Prev_de_Embarque)}
                </p>
                <p>
                  <b>Quantidade:</b>
                  {selectRow.Quantidade}
                </p>
                <p>
                  <b>Moeda:</b>
                  {formatarMoeda(selectRow.Moeda)}
                </p>
                <p>
                  <b>PV:</b>
                  {formatarValor(selectRow.PV, selectRow.Moeda)}
                </p>
                <p>
                  <b>Data de Venda:</b>
                  {formatarData(selectRow.Data_Venda)}
                </p>
                <p>
                  <b>Contrato:</b>
                  {selectRow.Contrato}
                </p>
                <p>
                  <b>Valor da Venda:</b>
                  {formatarValor(valorDaVenda, selectRow.Moeda)}
                </p>
                <p className="observacoes">
                  <b>Observações:</b>
                  {selectRow.Observacoes || "Nenhuma"}
                </p>
                <h6> Relatório de Câmbio </h6>
                <p>
                  <b>Câmbio Contratado Total:</b>
                  {formatarValor(cambioContratadoTotal, selectRow.Moeda)}
                </p>
                <p>
                  <b>Câmbio a Contratar:</b>
                  {formatarValor(
                    valorDaVenda - cambioContratadoTotal,
                    selectRow.Moeda
                  )}
                </p>
                <p>
                  <b>Média de Câmbio:</b>
                  {formatarValor(mediaCambio, selectRow.Moeda)}
                </p>
                <p>
                  <b>Valor em Real:</b>
                  {formatarValor(mediaCambio * cambioContratadoTotal, "BRL")}
                </p>
              </div>
              <button className="close" onClick={() => setShowDetalhes(false)}>
                <Close />
              </button>
            </div>
          );
        })()}

      <div className="controls">
        <Button
          ClassName="icon"
          OnClick={() => {
            setShowpoup(true);
            setCamposVazios([]);
          }}
        >
          <Add /> Nova Venda
        </Button>

        <span> Mostrar: </span>

        <Button
          ClassName={embarcadas ? "active" : "notActive"}
          OnClick={() => {
            setEmbarcadas((prev) => !prev);
          }}
        >
          Somente Embarcadas
        </Button>

        <Button
          ClassName={incompletas ? "active" : "notActive"}
          OnClick={() => {
            setIncompletas((prev) => !prev);
          }}
        >
          Somente Incompletas
        </Button>
      </div>

      <ThemeProvider theme={tableTheme}>
        <MaterialReactTable
          key={darkMode ? "dark" : "light"}
          columns={columns}
          data={filteredData}
          enableRowSelection={false}
          enableGlobalFilter={true}
          enableColumnOrdering={false}
          initialState={{ density: "comfortable" }}
          localization={MRT_Localization_PT_BR}
          enableEditing
          editDisplayMode="modal"
          muiTableBodyRowProps={({ row }) => ({
            onClick: () => {
              setShowDetalhes(true);
              setSelectRow(row.original);
            },
            style: { cursor: "pointer" },
          })}
          onEditingRowSave={({ values, row, table }) => {
            const dados = { ...row.original, ...values };

            const dadosSemNulos = Object.fromEntries(
              Object.entries(dados).filter(
                ([_, v]) => v !== null && v !== undefined
              )
            );

            PutApi("vendas", row.original.Venda_id, dadosSemNulos).then(() => {
              GetInfo();
              setTimeout(() => {
                table.setEditingRow(null);
              }, 1000);
            });
          }}
          renderRowActions={({ row, table }) => (
            <div style={{ display: "flex", gap: "0.5rem" }}>
              <Button
                ClassName="tableIcon edit"
                OnClick={(e) => {
                  table.setEditingRow(row);
                  e.stopPropagation();
                }}
                Title="Editar"
              >
                <EditIcon />
              </Button>

              <Button
                ClassName="tableIcon delete"
                OnClick={(e) => {
                  e.stopPropagation();

                  if (window.confirm("Deseja realmente deletar esta venda?")) {
                    DeleteApi("vendas", row.original.Venda_id)
                      .then(() => {
                        showToast("success", "Venda deletada com sucesso");
                        GetInfo();
                      })
                      .catch((err) => {
                        console.error(err);
                        showToast("error", "Erro ao deletar venda");
                      });
                  }
                }}
                Title="Deletar"
              >
                <DeleteIcon />
              </Button>
            </div>
          )}
        />
      </ThemeProvider>
    </div>
  );
}
